import { APP_TYPES } from "@lhd/components/CloneApp/constants";
import { ROUTES } from "@lhd/constants";
import { permissionConvert } from "@lhd/features/UserCompanies/CompanyDetail/utility";
import { useGetPermissionsEachPage } from "@lhd/hooks";
import { IPermissionItem } from "@lhd/types";
import { useSearchParams } from "react-router-dom";

const appID = "394";
const FALLBACK_PERMISSION: IPermissionItem = {
  create: true,
  edit: true,
  delete: true,
  view: true,
  all: true,
};

export interface ReceivedProps {
  permission?: string;
  headerExtend?: React.ReactNode;
  companyIdQuickView?: number;
}

const useList = ({ permission }: ReceivedProps) => {
  const [searchParams] = useSearchParams();
  const permissionsEachPage = useGetPermissionsEachPage();
  const newPermission =
    permissionConvert?.[permission as keyof typeof permissionConvert] ||
    (permissionsEachPage?.[ROUTES.FINANCIAL_REPORTS] as IPermissionItem) ||
    FALLBACK_PERMISSION;
  const pageMode =
    searchParams.get("page_mode") || searchParams.get("pageMode");
  const isEditMode = pageMode === "edit";

  return {
    appID,
    appType: APP_TYPES.FINANCIAL_REPORTS,
    url: ROUTES.FINANCIAL_REPORTS,
    permission: newPermission,
    hasQuickView: true,
    hiddenPaginationInURL: !pageMode,
    configShowBtnsOnHeader: {
      showDelete: !!pageMode,
      showShare: false,
      showAddNew: !!pageMode,
      disableDelete: !isEditMode,
      disableAddNew: !isEditMode,
    },
    configActionBtnsOnRow: {
      reorder: true,
    },
    configActionDisabledColumns: {
      checkbox: !isEditMode || !newPermission?.delete,
      editRow: !isEditMode,
      openQuickView: !pageMode,
      reorder: !isEditMode,
    },
    configBtnQuickView: {
      disableEdit: !isEditMode,
      disableView: !pageMode,
    },
    showColumnAction: !!pageMode,
  };
};

export type Props = ReturnType<typeof useList>;

export default useList;
